import { useEffect, useState } from 'react';

export const useIsSsr = () => {
  const [isSsr, setIsSsr] = useState(true);

  // We utilize the fact, that react's SSR functions, like renderToString, do not execute useEffects.
  useEffect(() => {
    setIsSsr(false);
  }, []);

  return { isSsr };
};
